module.exports = __webpack_public_path__ + "img/step-5.4b4a3ce5.jpg";